import { ItemDataService } from "data/service/item-data-service";
import { TreeViewDataService } from "data/service/treeview-data-service";
import { autoinject } from 'aurelia-dependency-injection';
import { Item, ItemType } from "data/entities/entities";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { TreeViewItem } from "core/tree-view-item";
import { DialogService } from 'aurelia-dialog';
import { EntityController } from "pages/entity/entity-controller";
import { EntityStatuses, ItemStatuses } from "core/enums";
import { AppEvents } from "core/app-events";
import { Router } from 'aurelia-router';
import { LogManager } from "aurelia-framework";
import searchTree from 'core/searchTree';
import * as $ from "jquery";
import { AddNewItemDialog } from './dialog/addNewItem/add-item-dialog';
import { MetadataService } from '../../../data/service/meta-data-service';



@autoinject()
export class TopLevelList {

	eventSubscriptions: Array<Subscription> = [];

	itemNameChangedSubscription: Subscription;
	selectRootSubcription: Subscription;
	itemDeletedSubscription: Subscription;
	itemMovedSubscription: Subscription;
	showTopLevelListContextMenuSubscription: Subscription;
	selectedItemChangedSubscription: Subscription;
	newItemAddedSubscription: Subscription;
	addNewItemSubscription: Subscription;
	refreshExplorerSubscription: Subscription;
	currentItemChangedSubscription: Subscription;
	directoryChangedSubscription: Subscription;

	onDirectoryChanged(data): any {
		this.getTopLevelItems();
	}

	currentTeam: string

	onAddNewItemByTypeId(itemTypeId: any): any {
		this.addItemByTypeId(itemTypeId);
	}

	//orientation = ej.Orientation.Vertical;
	type: any;
	treeView: any;
	item: Item = null;
	selectedItem: Item;
	contextMenu: HTMLElement;
	itemTypes: Array<ItemType>;
	logger = LogManager.getLogger('top-level-list');

	constructor(
		private controller: EntityController,
		private itemDataService: ItemDataService,
		private treeViewDataService: TreeViewDataService,
		private eventAggregator: EventAggregator,
		private dialogService: DialogService,
		private metadataService: MetadataService,
		private router: Router
		//private itemTypeDataService: ItemTypeDataService
	) {
		this.logger.info("Constructor()");
		//this.type = ej.Orientation.Vertical;
		

	}

	private subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.ITEM_NAME_CHANGED, payload => {
			this.onItemChanged(payload);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.SELECT_ROOT, () => {
			this.selectRoot();
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.ITEM_DELETED, item => {
			this.removeFromParent(item);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.ITEM_MOVED, item => {
			this.removeFromParent(item);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.SHOW_TOP_LEVEL_LIST_CONTEXT_MENU, (data) => this.showTopLevelListContextMenu(data)));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.SELECTED_ITEM_CHANGED, (data) => this.selectedItemChanged(data)));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.NEW_ITEM_ADDED, (item) => this.onNewItemAdded(item)));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.ADD_NEW_ITEM, (itemTypeId) => this.onAddNewItemByTypeId(itemTypeId)));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.REFRESH_EXPLORER, () => this.initializeData()));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.CURRENT_ITEM_CHANGED, (data) => this.onCurrentItemChanged(data)));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, (data) => this.onDirectoryChanged(data)));
	}

	attached() {
		this.logger.info("attached");
		this.initializeData();
		this.subscribeToEvents();
	}

	detached() {
		this.logger.info("detached");
		this.unsubscribeFromEvents();
	}

private unsubscribeFromEvents() {
	for (let entry of this.eventSubscriptions) {
		entry.dispose();
	}
	this.eventSubscriptions = [];
}

	//This fires when an item is activated by navigation, instead of by selecting the item in the Treeview.
	onCurrentItemChanged(payload) {
		this.logger.info("onCurrentItemChanged: " + payload.newValue.id);
		let id = payload.newValue.id;

		//If this is already the selected item, do nothing. This will happen if the user selects an item in the tree, and the app then 
		//navigates to it. 

		if (this.selectedItem && this.selectedItem.id === id) return;

		//Update the selected item, but don't process it
		this.selectedItem = payload.newValue;


		//Unselect the old node. ?? Not working well.
		//this.treeView.nodeSelected(this.selectedItem);

		//Select the new one.
		//ToDo- Refactor.
		//Get the treeview item.
		let treeViewItem: TreeViewItem = searchTree(this.item, id);

		if (treeViewItem) {
			this.openParentNode(treeViewItem, true);
			treeViewItem.nodeAspect.isSelected = true;
		}
	}
	//This is a router lifecycle method, but there is no deactivate, so typeically should not be used.
	activate() {
		this.logger.info("TopLevelList.Activate()");
		
	}
	//No such event is created for a component.
	deactivate() {
		this.logger.info("Deactivate");
	}

	editItem() {
		this.controller.editItem(this.controller.item);
	}

	//show(entityStatusId: EntityStatuses) {
	//	this.controller.getChildrenOfItem(this.controller.item, entityStatusId);
	//}

	onNewItemAdded(child: Item) {
		this.addNewChildToSelectedItem(child);
	}

	addNewChildToSelectedItem(child: Item) {
		this.treeView.wrapItem(child);
		this.selectedItem.children._add(child);
	}

	//hideMenu() {
	//	alert("Hide Menu");
	//}

	contextMenuItem: TreeViewItem;

	deleteContextMenuItem() {
		if (this.contextMenuItem) {
			this.controller.confirmDeleteItem(this.contextMenuItem);
		}
	}

	renameContextMenuItem() {
		this.contextMenuItem.nodeAspect.isEditing = true;
	}

	showTopLevelListContextMenu(data: any) {
		let e: any = data[0];
		this.contextMenuItem = data[1];



		this.setSelectedItem(this.contextMenuItem);

		let d: any = document.getElementById('topLevelListMenu');
		d.style.position = "absolute";
		d.style.left = e.clientX + 'px';
		d.style.top = e.clientY + 'px';
		d.style.display = 'block';

		$(document).bind("click", function (event) {
			document.getElementById("topLevelListMenu").style.display = "none";
		});


	}


	removeFromParent(itemToRemove: Item) {
		let foundItem = this.findItemById(itemToRemove.id, this.item);
		if (foundItem) {
			let parent: Item = foundItem.parent;
			if (parent) {
				parent.children._remove(foundItem);
				if (this.selectedItem.id === itemToRemove.id) {
					this.treeView.nodeSelected(parent);
				}

			}
		}
	}

	addItemByDialog() {

		
	}

	async addItemByTypeId(itemTypeId: number) {
		this.logger.info("addItemByTypeId()" + itemTypeId);
		let child = this.itemDataService.getNew();
		//child.name = "new";
		child.parentId = this.selectedItem.id;
		child.entityStatusId = EntityStatuses.Active;
		child.itemStatusId = ItemStatuses.New;
		child.itemTypeId = itemTypeId;


		this.dialogService.open({ viewModel: AddNewItemDialog, model: child }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.saveNewItem(child);
			}
			else {

			}
		});
	}

	async saveNewItem(item) {
		var newItem = await item.save();
		item.parent = this.selectedItem;
		//item.isEditing = true;
		this.treeView.wrapItem(newItem);
		this.selectedItem.children.push(newItem);
		this.treeView.nodeSelected(newItem);
		this.metadataService.getMetadata();
	}

	initializeData() {
		this.getTopLevelItems();

	}
	//This is coming from the user action when a new item is selected in the treeview.
	selectedItemChanged(data) {
		this.logger.info("selectedItemChanged()");
		if (data.newValue) {
			if (this.selectedItem && (data.newValue.id === this.selectedItem.id)) {
				return;
			}
			this.setSelectedItem(data.newValue);
		}
	}

	setSelectedItem(item: Item) {
		this.logger.info("setSelectedItem");
		if (item === null) return;

		if (this.selectedItem) if (this.selectedItem.id === item.id) return;

		this.logger.info("Selected Item Changed: " + item.id);
		this.selectedItem = item;
		this.openParentNode(item as any);
		if (item.isEditing) {
			item.isEditing = false;
			this.router.navigate(`#/app/explorer/entity/${item.id}?isEditing`)

		} else {
			this.router.navigate(`#/app/explorer/entity/${item.id}`);
		}

	}

	openParentNode(item: TreeViewItem, recursive: boolean = false) {
		this.logger.info("openParentNode()" + item.id);
		if (item.parent) {
			item.nodeAspect.isExpanded = true;
			if (recursive) this.openParentNode(item.parent, recursive);
		}
	}

	selectRoot() {
		this.logger.info("selectRoot()");
		
		if (this.item) {
			this.setSelectedItem(this.item);
		}
		else {
			this.logger.error("Could not set root");
		}
	}
	

	onItemChanged(changedItem: Item) {
		this.updateItemName(changedItem);
	}

	updateItemName(changedItem) {
		let existingItem = this.findItemById(changedItem.id, this.item);

		if (existingItem) {
			existingItem.name = changedItem.name;
		}
	}

	findItemById(idToFind: number, searchRoot): TreeViewItem {

		if (!searchRoot) return null;

		if (searchRoot.id === idToFind) {
			return searchRoot;
		}
		let foundItem = null;
		for (let i of searchRoot.children) {
			foundItem = this.findItemById(idToFind, i);
			if (foundItem) {
				break;
			}
		}

		return foundItem;

	}

	save(item: Item) {
		this.logger.info("TopLevelList.save()");
		this.treeViewDataService.save(item);
		this.eventAggregator.publish(AppEvents.ITEM_NAME_CHANGED, item);
	}

	afterAttached() {
		this.logger.info("after-attached()");
		if (this.selectedItem) {
			this.treeView.nodeSelected(this.selectedItem);
		}
		



	}

	initMenu() {
		$("#topLevelListMenu").ejMenu({ width: 47 });
	}

	onMetadataComplete() {
		this.initMenu();
	}

	onSelect(e) {
		let id = e.detail.nodes[0].payload.id;
		this.router.navigate(`#/app/explorer/entity/${id}`);

	}

	//Always get fresh data, as the directory may have changed.
	async getTopLevelItems() {
		this.logger.info("top-level-list.getTopLevelItems()");
		try {
			this.item = await this.treeViewDataService.getTopLevelItemAndChildren();
			//Don't automatically set the root item. 
			this.eventAggregator.publish(AppEvents.EXPLORER_REFRESHED);
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	
	

	fireSelectedItemChanged(item: Item) {
		this.eventAggregator.publish(AppEvents.SELECTED_ITEM_CHANGED, { newValue: item, oldValue: null });
	}

}